import { Partner } from "../types";
import ApiModule from "./base";

export default class PartnersModule extends ApiModule {
  constructor(baseURL: string) {
    super(baseURL, "partners");
  }

  async index(): Promise<Array<Partner>> {
    const request = new Request(`${this.url}`, {
      method: "GET",
      headers: this._defaultHeaders(),
    });
    return await this._resolve(request);
  }
}
